module.exports = __webpack_public_path__ + "img/tpay-we.b2b2e2d8.png";